
<div class="container-fluid">
  <div class="row">
    <div class="col"><h4>{{process?.company.name}}</h4></div>
  </div>
  <div class="d-flex justify-content-between align-content-center">
    <span class="text-muted pt-1 pb-2">
      <span class="d-flex flex-row">
        <h5 class="mb-2">{{process?.status}}</h5>
        <h6 class="pt-1 ps-1 mx-1">{{process?.createDate | date: 'dd/MM/yyyy'}} - </h6>
        <h6 class="pt-1 ps-1 mx-1">{{process?.createdBy}}</h6>
        <h6 class="pt-1 ps-1 mx-1">({{process?.uniqueId}})</h6>
      </span>
    </span>
    @if (this.user?.roles.includes('CONTROLLER')) {
      <span class="text-muted pt-1 pb-2">
        <!--          <span class="d-flex flex-row align-content-between">-->
        <div class="btn-group">
          <button type="button" class="btn btn-outline-danger" (click)="openModal(template, this.process.id)">{{'CONTROL-MODULE.DELETE' | translate}}</button>
        </div>
      <!--          </span>-->
    </span>
  }
</div>

<div class="d-flex">
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills" orientation="vertical" (navChange)="changeTab($event)">
    @for (step of steps; track step) {
      <li ngbNavItem="{{step.key}}">
        <a ngbNavLink>{{step.name}}</a>
        <ng-template ngbNavContent>
          <app-step [process]="process" [activeTaskKey]="activeTaskKey"
            (onReloadProcess)="reloadProcess(process.id)"
          [step]="step" [tasks]="getTasks(step.key)"></app-step>
        </ng-template>
      </li>
    }
    @if (steps) {
      <li ngbNavItem="timeline">
        <a ngbNavLink>Timeline</a>
        <ng-template ngbNavContent>
          <app-timeline></app-timeline>
        </ng-template>
      </li>
    }
    @if (steps) {
      <li ngbNavItem="timesheet">
        <a ngbNavLink>Timesheet</a>
        <ng-template ngbNavContent>
          <app-timesheet [user]="user"></app-timesheet>
        </ng-template>
      </li>
    }
    @if (steps) {
      <li ngbNavItem="Documents">
        <a ngbNavLink>Documents</a>
        <ng-template ngbNavContent>
          <app-documents></app-documents>
        </ng-template>
      </li>
    }
  </ul>
  <div [ngbNavOutlet]="nav" class="container-fluid bgk"></div>
</div>
<ng-template #template>
  <div class="modal-body text-center">
    <p>{{'CONTROL-MODULE.SURE_TO_DELETE_CONTROL' | translate}}</p>
    <button type="button" class="btn btn-outline-secondary" (click)="confirm()" >{{'CONTROL-MODULE.YES' | translate}}</button>
    <button type="button" class="btn btn-primary" (click)="modalRef?.hide()" >{{'CONTROL-MODULE.CANCEL' | translate}}</button>
  </div>
</ng-template>
</div>
